export interface RevenueYear {
  year: string
  display: string
  exact: string
  /** Actual model value, used only to scale the bars honestly. */
  value: number
}

export const revenueYears: RevenueYear[] = [
  { year: 'Year 1', display: '$0.91M', exact: '$908,075', value: 908075 },
  { year: 'Year 2', display: '$4.51M', exact: '$4,506,551', value: 4506551 },
  { year: 'Year 3', display: '$11.91M', exact: '$11,908,493', value: 11908493 },
]

export const yearThreeScale = [
  { value: '20,982', label: 'Paid app subscribers' },
  { value: '1,441', label: 'Active business customers' },
]

export const cashFlowMilestone = {
  when: '~ Month 16',
  label: 'Operating cash-flow positive',
}

export const opportunityShare = {
  value: '~0.13%',
  lead: 'Year-3 revenue represents only',
  label: 'of the illustrative focused U.S. revenue opportunity ($9.23B)',
}

export const revenueEngines = [
  { name: 'VEXU App', model: 'Subscription + Usage' },
  { name: 'VEXU Business', model: 'Platform + Usage + Expansion' },
]

export const executionPath = [
  '$2.5M SAFE',
  'U.S. launch',
  'Scale VEXU App',
  'Expand VEXU Business',
  'Year-3 base case',
]
